// 実行時設定。デプロイ時に CDK が /config.json を生成して S3 に置く（lib/shared/portal-web-stack.ts）。
// ローカル開発では public/config.json を使う。

export interface RuntimeConfig {
  portalApiBase: string;
  authApiBase: string;
  cognitoDomain: string;
  userPoolId: string;
  clientId: string;
}

let cached: RuntimeConfig | null = null;

export async function loadConfig(): Promise<RuntimeConfig> {
  if (cached) return cached;
  const res = await fetch("/config.json", { cache: "no-store" });
  if (!res.ok) throw new Error(`config.json を読めない: ${res.status}`);
  const c = (await res.json()) as RuntimeConfig;
  cached = { ...c, portalApiBase: trimSlash(c.portalApiBase), authApiBase: trimSlash(c.authApiBase), cognitoDomain: trimSlash(c.cognitoDomain) };
  return cached;
}

export function getConfig(): RuntimeConfig {
  if (!cached) throw new Error("config not loaded");
  return cached;
}

export const trimSlash = (s: string) => s.replace(/\/+$/, "");
